import { Injectable } from '@angular/core';
import { UserIdleService } from 'angular-user-idle';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { UserIdleModalComponent } from '../shared/user-idle-modal/user-idle-modal.component';
import { AuthenticationService } from './authentication.service';
import { ApsAssignedFacade } from '../ngrx/aps_assinged/aps_assinged.facade';
import { StorageService } from './storage.service';
import * as moment from 'moment';
import { DataExpiryModalComponent } from '../shared/data-expiry-modal/data-expiry-modal.component';
import { FormDataFacade } from '../ngrx/form-data/form-data.facade';
import { AuthFacade } from '../ngrx/auth/auth.facade';

@Injectable({
  providedIn: 'root'
})
export class GlobalService {

constructor(
  private modalService: BsModalService,
  private modalServiceDataExpiry: BsModalService,
  private authService: AuthenticationService,
  private apsAssignedFacade: ApsAssignedFacade,
  private userIdle: UserIdleService,
  private storage: StorageService,
  private formDataFacade: FormDataFacade,
  private authFacade: AuthFacade
) { }
  bsModalRef: BsModalRef;
  bsModalRefExpiryData: BsModalRef;
  getSideBarVisibility() {
    const screenSize = window.innerWidth;
    if (screenSize < 768) {
      return false;
    }
    return true;
  }

  checkUserIdle() {
    // Start watching for user inactivity.
    const assignedAgentId = this.storage.getLocalValue('selectedAssignedAgentId');
    this.authFacade.getDataFromDB(assignedAgentId).then(
      data => {
        console.log('data.max_idle!', data.max_idle);
        this.userIdle.stopWatching();
        this.userIdle.setConfigValues({idle: data.max_idle});
        this.userIdle.startWatching();

        // Start watching when user idle is starting.
        this.userIdle.onTimerStart().subscribe(() => {});

        // Start watch when time is up.
        this.userIdle.onTimeout().subscribe(() => {
          this.authService.logout();
        });
        let activeTime = moment();
        this.userIdle.ping$.subscribe(
          () => {
            const a = activeTime;
            const b = moment().utcOffset(a.format('Z'));
            if (moment.duration(b.diff(a)).asSeconds() >= data.max_idle ) {
              this.authService.logout();
            } else {
              if (!document.hidden) {
                activeTime = moment();
              }
            }
            this.checkForExpiredData();
          }
        );
      }
    );
  }

  displayIdleModal() {
    const initialState = {};
    this.modalService.config.ignoreBackdropClick = true;
    this.modalService.config.class = 'modal-lg';
    this.bsModalRef = this.modalService.show(UserIdleModalComponent, {initialState});
  }

  checkForExpiredData() {
    const assignedAgentId = +this.storage.getLocalValue('selectedAssignedAgentId');
    this.apsAssignedFacade.getApsAssignedCheckOutList(assignedAgentId).subscribe(
      data => {
        const expiredIDs = [];
        data.map(
          list => {
            this.formDataFacade.getDataFromDB(list.aps_report_load_id, assignedAgentId).then(
              reportLoad => {
                if (reportLoad !== null && reportLoad !== undefined && reportLoad.data.expiration !== undefined) {
                  console.log('checkExpired', expiredIDs);
                  const a = moment(new Date(reportLoad.data.expiration));
                  const b = moment();
                  if (moment.duration(a.diff(b)).asHours() <= 0) {
                    expiredIDs.push(list.aps_report_load_id);
                  }
                }
              }
            );
          }
        );
        setTimeout(() => {
          if (expiredIDs.length > 0 && this.modalServiceDataExpiry.getModalsCount() === 0) {
            const initialState = {
              expiredIDs
            };
            this.modalServiceDataExpiry.config.ignoreBackdropClick = true;
            this.modalServiceDataExpiry.config.class = 'modal-lg';
            this.bsModalRefExpiryData = this.modalServiceDataExpiry.show(DataExpiryModalComponent, {initialState});
          }
          if (expiredIDs.length === 0 && this.modalServiceDataExpiry.getModalsCount() > 0 && this.bsModalRefExpiryData !== undefined) {
            this.bsModalRefExpiryData.hide();
          }
        }, 300);
      }
    );
  }

  deleteExpiredData() {
    const expiredIDs = [];
    this.apsAssignedFacade.getApsAssignedCheckOutListWithObservable().then(
      data => {
        data.map(
          list => {
            this.formDataFacade.getDataFromDB(list.aps_report_load_id).then(
              reportLoad => {
                if (reportLoad !== null && reportLoad !== undefined && reportLoad.data.expiration !== undefined) {
                  const a = moment(new Date(reportLoad.data.expiration));
                  const b = moment();
                  if (moment.duration(a.diff(b)).asHours() <= 0) {
                    expiredIDs.push(list.aps_report_load_id);
                  }
                }
              }
            );
          }
        );
        setTimeout(() => {
          if (expiredIDs.length > 0 && this.modalServiceDataExpiry.getModalsCount() === 0) {
            this.formDataFacade.deleteDataToDB(expiredIDs);
            this.apsAssignedFacade.deleteApsAssignedCheckOutItem(expiredIDs);
          }
        }, 100);
      }
    );
  }

}
